import * as React from "react";
const SvgIcSubtract = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth={2} d="M20 12H4" /></svg>;
export default SvgIcSubtract;